module.exports = __webpack_public_path__ + "img/building.dea7640f.svg";